import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { ExtractionPrompt as ExtractionPromptType, ExtractionPromptListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const EXTRACTION_PROMPT_FIELDS = `active createdBy createdDate id model notes prompt promptVersion stage updatedDate version`

const LIST_QUERY = graphql(`
  query ExtractionPrompts($search: String, $pagination: PaginationInput, $sort: SortInput) {
    extractionPrompts(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        active
        createdBy
        createdDate
        id
        model
        notes
        prompt
        promptVersion
        stage
        updatedDate
        version
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query ExtractionPrompt($slug: String!) {
    extractionPrompt(slug: $slug) {
      active
      createdBy
      createdDate
      id
      model
      notes
      prompt
      promptVersion
      stage
      updatedDate
      version
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateExtractionPrompt($input: CreateExtractionPromptInput!) {
    createExtractionPrompt(input: $input) {
      active
      createdBy
      createdDate
      id
      model
      notes
      prompt
      promptVersion
      stage
      updatedDate
      version
    }
  }
`)

export class ExtractionPromptStore extends EntityStore<
  ExtractionPromptType,
  ExtractionPromptListResult,
  typeof CREATE_MUTATION,
  undefined
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      createMutation: CREATE_MUTATION,
      extractList: (data: any) => data.extractionPrompts,
      extractOne: (data: any) => data.extractionPrompt,
      extractMutated: (data: any) => data.updateExtractionPrompt ?? data.createExtractionPrompt,
    })
  }
}
